<template>
  <form @submit.prevent="handleSubmit" id="template_create_form">
    <!-- Template Name -->
    <div class="mb-3">
      <label class="form-label form-label-thin">Template Name <span class="text-danger">*</span></label>
      <input type="text" class="form-control form-control-thin" id="name" name="name" ref="name"
        v-model="form.name" placeholder="Template Name" />
    </div>

    <div class="mb-3">
      <label class="form-label form-label-thin">Doc No <span class="text-danger">*</span></label>
      <input type="text" class="form-control form-control-thin" id="doc_no" name="doc_no" ref="doc_no"
        v-model="form.doc_no" placeholder="Document Number" />
    </div>

    <div class="mb-3">
      <label class="form-label form-label-thin">Attachment File</label>
      <input type="file" class="form-control form-control-thin" id="file" name="file" 
        @change="form.file = $event.target.files[0]" />
      <small class="text-muted">Max size: 10MB</small>
    </div>

    <div class="mb-3">
      <label class="form-label form-label-thin">Description If Any</label>
      <textarea class="form-control form-control-thin" id="description" name="description" ref="description"
        v-model="form.description" placeholder="Template Description" rows="2"></textarea>
    </div>
   
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-danger btn-sm hover-white" @click="close">
        <i class="fa fa-times"></i> Cancel
      </button>
      <button type="submit" class="btn btn-primary text-light hover-white btn-md form-submit-btn" :disabled="submitting">
        <i class="fa fa-save"></i> {{ submitting ? 'Creating...' : 'Create Template' }}
      </button>
    </div>

  </form>
  
</template>

<script>
import { form_api_submit } from '@/utils/FormSubmit'

export default {
  name: 'CreateTemplate',
  
  emits: ['created', 'close'],
  data() {
    return {
      form: {
        name: '',
        doc_no: '',
        description: '',
        file: null
      },
      submitting: false,
    }
  },
  methods: {
    async handleSubmit() {
      this.submitting = true

      const result = await form_api_submit({
        url: 'template/create',
        method: 'POST',
        data: this.form,
        take_form_data: true,
        curr_form_id: '#template_create_form',
      })

      if (result.success) {
        this.$emit('created')
        this.close()
        this.resetForm()
      }

      this.submitting = false
    },

    close() {
      this.$emit('close')
    },

    resetForm() {
      this.form = {
        name: '',
        description: '',
        head: '',
        members: []
      }
      // Reset select2 values
      if (typeof $ !== 'undefined') {
        $('#head').val(null).trigger('change');
        $('#members').val(null).trigger('change');
      }
    }
  }
}
</script>